import React from 'react';

const ReadonlyField = ({ label, value, isDark, required = false, type = 'text', placeholder = '', multiline = false, rows = 3 }) => {
    return (
        <div className="flex flex-col gap-[8px]">
            {label && (
                <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                    isDark ? 'text-white' : 'text-[#072837]'
                }`}>
                    {label} {required && <span className="text-red-500">*</span>}
                </p>
            )}
            {multiline ? (
                <textarea
                    className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent resize-none ${
                        isDark ? 'bg-[#161515] text-white' : 'bg-[#f5f5f5] text-[#072837]'
                    }`}
                    rows={rows}
                    value={value || ''}
                    readOnly
                    placeholder={placeholder}
                />
            ) : (
                <input
                    className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent ${
                        isDark
                            ? 'bg-[#161515] text-white'
                            : 'bg-[#f5f5f5] text-[#072837]'
                    }`}
                    type={type}
                    value={value || ''}
                    readOnly
                    placeholder={placeholder}
                />
            )}
        </div>
    );
};

export default ReadonlyField;
